export default __webpack_public_path__ + "static/media/doc_ico.b29bd478.svg";